<template>
  <div :class="getButtonClass" @click.prevent="showPopup">
    {{ $t("starter.start_trial") }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PromoBuyButton",

  props: {
    buttonColor: {
      type: String,
      default: "gold",
    },
  },

  computed: {
    ...mapGetters("global", ["userHasAccess"]),
    getButtonClass() {
      return [
        "button button--corner button--animated promo__button",
        `button--${this.buttonColor}`,
        `gtm-button gtm-tariff-screen`,
      ];
    },
  },

  methods: {
    showPopup() {
      this.$emit("showPopup");
    },
  },
};
</script>
